import { render, staticRenderFns } from "./VATRecoverability.vue?vue&type=template&id=2a472db3&scoped=true"
import script from "./VATRecoverability.vue?vue&type=script&lang=ts"
export * from "./VATRecoverability.vue?vue&type=script&lang=ts"
import style0 from "./VATRecoverability.vue?vue&type=style&index=0&id=2a472db3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a472db3",
  null
  
)

export default component.exports